import type React from 'react';
import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';
import { ROUTES } from '../../../constants/Constants';
import useAppNavigation from '../../../hooks/useAppNavigation';
import { confirmRequest } from '../../../redux/ducks/AuthDucks';
import type { RootReducerType } from '../../../redux/reducers/RootReducer.types';
import type { AppSsrFetchedDataType } from '../../../server/AppSsr';
import Spinner from '../../layout/Spinner/Spinner';

interface ConfirmProps {
  ssrFetchedData: AppSsrFetchedDataType;
}

const Confirm: React.FC<ConfirmProps> = ({ ssrFetchedData }) => {
  const [searchParams] = useSearchParams();
  const [onConfirm, setOnConfirm] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { navigate, toLocalizedRoute } = useAppNavigation();

  const { confirmResponse } = useSelector(
    (state: RootReducerType) => state.auth,
  );

  useEffect(() => {
    const confirmationCode = searchParams.get('code');
    if (confirmationCode) {
      setOnConfirm(true);
      dispatch(confirmRequest({ code: confirmationCode }));
    } else {
      toast.error(t('static.confirm.notification_code_not_found'));
      navigate(toLocalizedRoute(ROUTES.HOME_ROUTE));
    }
  }, []);

  useEffect(() => {
    const confirmationCode = searchParams.get('code');
    if (confirmationCode && onConfirm && confirmResponse) {
      if (confirmResponse?.error) {
        toast.error(t('static.confirm.notification_code_not_valid'));
      } else {
        toast.success(t('static.confirm.notification_success'));
      }

      navigate(toLocalizedRoute(ROUTES.HOME_ROUTE));
    }
  }, [confirmResponse]);

  return (
    <div className="flex min-h-[calc(100dvh)] flex-col items-center justify-center">
      {onConfirm ? (
        <Spinner color="fill-sky-600" />
      ) : (
        <div className="flex flex-col">Account confirmed!</div>
      )}
    </div>
  );
};

export default Confirm;
